
<template>
    <v-container fluid class="pa-0 ma-0"> 
        <v-row no-gutters>
            <v-col v-for="week in weeks" cols="4" class="text-center table-head primary--text" :key="week">
                <doc-text-field 
                    v-if="typeof kpis_data[data][week] != 'object'" 
                    dense 
                    hide-details 
                    :value="kpis_data[data][week]" 
                    kind="text" 
                    readonly 
                    :font_weight_black="data=='Total'" 
                    :primary_color_text="data=='Total'" 
                    :right_input="true">
                </doc-text-field>
                <!-- <v-tooltip top v-else :disabled="!kpis_data[data][week]['training']" :open-on-hover="true">
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on"> -->

                            <doc-text-field 
                                v-else
                                dense 
                                hide-details 
                                :value="kpis_data[data][week][show_doc]" 
                                kind="text" 
                                readonly 
                                :font_weight_black="data=='Total'" 
                                :primary_color_text="data=='Total'" 
                                :right_input="true"
                                :error="(show_doc == 'text') ? Boolean(kpis_data[data][week]['color']) : Boolean(kpis_data[data][week]['training_color'] )"
                                :errorColor="(show_doc == 'text') ? kpis_data[data][week]['color'] : kpis_data[data][week]['training_color']">
                            </doc-text-field>
                        <!-- </div>
                    </template>
                    <span>{{kpis_data[data][week]['training']}}</span>
                </v-tooltip> -->
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DocTextField from './DocTextField.vue';
import { mapFields } from 'vuex-map-fields';

export default {
    components: {
        DocTextField,
    },
    props: {
        weeks: {
            type: [Object, Array],
            required: true,
        },
        kpis_data: {
            type: Object,
            required: true,
        },
        data: {
            type: String,
            required: true,
        }
    },
    computed: { 
        ...mapFields('kpis', [
            'show_doc',
        ]),
    }
};
</script>

<style scoped>
    .table-head{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
</style>